// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { promotionCodeFormStyles } from "@keller/Overrides/Widgets/CheckoutReviewAndSubmit/CheckoutReviewAndSubmitPromotionCode";
import { css } from "styled-components";

promotionCodeFormStyles.applyButton = {
    variant: "primary",
    typographyProps: {
        size: 10,
        weight: "bold",
        css: css`
            line-height: 11px;
            letter-spacing: 0;
        `,
    },
    css: css`
        padding: 0 22px;
        height: 38px;
    `,
};
